import useSWR from 'swr';
import { fetcher } from '../index';

export default function useVisits() {
	const { data, error } = useSWR('/api/v1/comocat/visits', fetcher);

	return {
		visits: data,
		isLoading: !data && !error,
		error: error
	};
}
